export default class ActivitySortController {
  constructor(element) {
    this.element = element
    this.tabs = Array.from(element.querySelectorAll('[data-activity-sort-target="tab"]'))
    this.list = element.querySelector('[data-activity-sort-target="list"]')
    this.items = Array.from(element.querySelectorAll('[data-activity-sort-target="item"]'))
  }

  sort(mode) {
    // Update active tab
    this.tabs.forEach(tab => {
      tab.classList.toggle("filter-tab--active", tab.dataset.sort === mode)
    })

    // Show/hide based on mode
    this.items.forEach(item => {
      const type = item.dataset.itemType
      const isSeller = item.dataset.itemSeller === "true"

      let visible = true
      if (mode === "upvoted") visible = type === "comment"
      else if (mode === "seller") visible = type === "comment" && isSeller
      else if (mode === "bids") visible = type === "bid"

      item.style.display = visible ? "" : "none"
    })

    // Sort visible items
    const visible = this.items.filter(item => item.style.display !== "none")
    const hidden = this.items.filter(item => item.style.display === "none")

    visible.sort((a, b) => {
      if (mode === "upvoted") {
        const likesA = parseInt(a.dataset.itemLikes || "0", 10)
        const likesB = parseInt(b.dataset.itemLikes || "0", 10)
        if (likesB !== likesA) return likesB - likesA
      }
      return parseInt(b.dataset.itemTime || "0", 10) - parseInt(a.dataset.itemTime || "0", 10)
    })

    // Re-append in sorted order
    visible.forEach(item => this.list.appendChild(item))
    hidden.forEach(item => this.list.appendChild(item))

    // Scroll to top of list
    this.list.scrollTop = 0
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="activity-sort"]').forEach(el => {
    const controller = new ActivitySortController(el)

    el.querySelectorAll('[data-action*="activity-sort#sort"]').forEach(btn => {
      btn.addEventListener('click', (event) => {
        event.preventDefault()
        controller.sort(btn.dataset.sort)
      })
    })
  })
})
